var map = {
	"./caller.jpg": 79718,
	"./coming-soon-bg.jpg": 53970,
	"./img-cropper.jpg": 15918,
	"./maintenance-bg.jpg": 58168,
	"./mobile-clock-wallpaper.jpg": 23557,
	"./receiver-img.jpg": 63358,
	"./sidebar-bg.jpg": 41603
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54014;